module.exports = __webpack_public_path__ + "public/images/tiger.7cc748c08d73f0bc24399420a54b7814.svg";